import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { projects } from "../data/projects";
import { ProjectCard } from "../components/ProjectCard";

const featured = projects.filter((p) => p.featured).slice(0, 3);

export default function Home() {
  return (
    <div data-testid="home-page">
      <section className="mx-auto max-w-6xl px-6 pb-20 pt-16 sm:px-10 sm:pb-28 sm:pt-28">
        <p className="font-mono-label reveal mb-6">Web developer · United States</p>
        <h1 className="reveal max-w-3xl text-4xl font-extrabold leading-[1.05] sm:text-5xl lg:text-6xl" style={{ animationDelay: "80ms" }}>
          I build fast, quiet websites that
          <span className="text-[#FF4D00]"> do one job well</span>.
        </h1>
        <p className="reveal mt-8 max-w-xl text-base leading-relaxed text-muted-foreground sm:text-lg" style={{ animationDelay: "160ms" }}>
          I'm John Doe. For eleven years I've shipped web apps, platforms, and
          marketing sites for small teams who care about speed, clarity, and
          shipping on time.
        </p>
        <div className="reveal mt-10 flex flex-wrap items-center gap-4" style={{ animationDelay: "240ms" }}>
          <Link
            to="/contact"
            data-testid="home-cta-contact"
            className="inline-flex items-center gap-2 rounded-sm bg-[#FF4D00] px-6 py-3 text-sm font-medium text-white transition-transform hover:-translate-y-0.5"
          >
            Start a project <ArrowRight size={16} />
          </Link>
          <Link
            to="/work"
            data-testid="home-cta-work"
            className="link-underline text-sm text-foreground/80 hover:text-foreground"
          >
            See all work
          </Link>
        </div>
      </section>

      <section className="border-y border-border bg-card">
        <div className="mx-auto grid max-w-6xl grid-cols-2 divide-border sm:grid-cols-4 sm:divide-x">
          {[
            ["11 yrs", "Building for the web"],
            ["40+", "Projects shipped"],
            ["98", "Avg. mobile Lighthouse"],
            ["2 wks", "Typical start time"],
          ].map(([big, small]) => (
            <div key={small} className="border-b border-border px-6 py-8 sm:border-b-0 sm:px-8">
              <p className="text-2xl font-bold">{big}</p>
              <p className="font-mono-label mt-2 normal-case tracking-normal">{small}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 py-20 sm:px-10 sm:py-28" data-testid="home-featured-section">
        <div className="mb-12 flex items-end justify-between">
          <div>
            <p className="font-mono-label mb-3">Selected work</p>
            <h2 className="text-base font-bold sm:text-lg">Three recent projects</h2>
          </div>
          <Link to="/work" data-testid="home-featured-all-link" className="link-underline text-sm text-[#FF4D00]">
            All projects
          </Link>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((p, i) => (
            <ProjectCard key={p.slug} project={p} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
